var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "url(#paint0_linear_3018_1661)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1927 27.2316H30.2424L32.7157 33.1368H11.2852L13.7584 27.2305H15.8081",
    stroke: "white",
    strokeWidth: 1.40704
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2342 29.7289C22.2342 29.7289 30.0494 23.867 30.0494 18.6399C30.0505 14.585 27.119 11.166 22.2342 11.166C17.3484 11.166 14.418 14.585 14.418 18.6399C14.418 23.867 22.2342 29.7289 22.2342 29.7289Z",
    stroke: "white",
    strokeWidth: 1.40704
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3379 16.041H24.1296V19.8327H20.3379V16.041Z",
    stroke: "white",
    strokeWidth: 1.40704
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3018_1661",
    x1: 44,
    y1: 44,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#277AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C6F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map_icon.622aed2e6b1568ae522f6a08304f1e67.svg";
export { ForwardRef as ReactComponent };